import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  prfDelSync01ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  prfDelSync01GoToDocument: ['hdrId'],
  prfDelSync01FetchPrfDelSync01: ['currentPage', 'sorts', 'filters', 'pageSize'],
  prfDelSync01FetchPrfDelSync01Loading: ['boolean'],
  prfDelSync01FetchPrfDelSync01Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  prfDelSync01AddSelectedDocuments: ['selectedDocuments'],
  prfDelSync01RemoveSelectedDocuments: ['selectedDocuments'],
  prfDelSync01SetWorkspaceVisible: ['boolean'],

  prfDelSync01SyncNow: ['hdrIds'],
  prfDelSync01SyncNowSuccess: null,
  prfDelSync01SyncLoading: ['boolean']
});

export const PrfDelSync01Types = Types;
export default Creators;
